import Button from '@atlaskit/button';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from '@atlaskit/modal-dialog';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useModalHandlers } from 'hooks';
import { ROUTE_PATHS } from 'settings';

export default function VersionChecker() {
  const { isOpenModal, openModal } = useModalHandlers();

  const navigate = useNavigate();

  useEffect(() => {
    const checkVersion = () => {
      fetch('/version.txt', {
        method: 'GET',
        headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache', Expires: '0' },
      })
        .then((response) => response.text())
        .then((data) => {
          const version = `${data}`.trim();
          const commitHash = `${process.env.REACT_APP_GIT_COMMIT_HASH}`.trim();

          if (!version || version.length !== 40) return;
          if (!version.includes(commitHash)) {
            openModal();
          }
        })
        .catch(() => navigate(ROUTE_PATHS.VPN.INDEX));
    };
    checkVersion();

    window.addEventListener('focus', checkVersion);

    return () => {
      window.removeEventListener('focus', checkVersion);
    };
  }, [navigate, openModal]);

  return (
    <ModalTransition>
      {isOpenModal ? (
        <Modal shouldCloseOnOverlayClick={false} shouldCloseOnEscapePress={false}>
          <ModalHeader>
            <ModalTitle>Update available!</ModalTitle>
          </ModalHeader>
          <ModalBody>Please reload the app to apply the latest changes.</ModalBody>
          <ModalFooter>
            <Button appearance="primary" onClick={() => window.location.reload()}>
              Reload
            </Button>
          </ModalFooter>
        </Modal>
      ) : null}
    </ModalTransition>
  );
}
